var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "lead" }, [_vm._v("選択した記事を削除しますか")]),
    _vm._v(" "),
    _c("div", { staticClass: "buttonDialogPosition" }, [
      _c(
        "button",
        { staticClass: "button large", on: { click: _vm.submitEvent } },
        [_vm._v("削除")]
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "close-button",
        attrs: { "aria-label": "Close reveal", type: "button" },
        on: { click: _vm.close }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }